/**
 * Handels the commercial bill and estimate after the decarbonisation process
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DataServiceProvider } from '../../providers/data-service/data-service';
@Component({
  selector: 'commercials',
  templateUrl: 'commercials.html'
})
export class CommercialsComponent {
  @Input() mode: string;
  @Input() commercials: any;
  @Output() change: EventEmitter<any> = new EventEmitter();
  text: string;

  constructor(public $data: DataServiceProvider) {

  }

  valueChange(event, attrName) {
    this.commercials[attrName] = event.value;
    this.calculateTotal();
    this.emitChanges();
  }

  calculateTotal() {
    this.commercials.total = this.commercials.hhoPrice - this.commercials.specialDiscount + this.calculateTaxes(this.commercials);
  }

  numberToEnglish(number) {
    return this.$data.numberToEnglish(number)
  }

  emitChanges() {
    this.change.emit(this.commercials);
  }

  calculateTaxes(commercials) {
    let taxableAmount = commercials.hhoPrice - commercials.specialDiscount;
    return (this.getTaxAmount(taxableAmount, commercials.sGst) +
      this.getTaxAmount(taxableAmount, commercials.iGst) +
      this.getTaxAmount(taxableAmount, commercials.otherTax));
  }

  getTaxAmount(taxableAmount, taxPercentage) {
    return (taxableAmount * taxPercentage * 0.01)
  }



}



// WEBPACK FOOTER //
// ./src/components/commercials/commercials.ts